var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.053,
    height: 45.64,
    viewBox: "0 0 76.053 45.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8725432_arrow_growth_icon",
    "data-name": "8725432_arrow_growth_icon",
    d: "M77.743,8.357A3.86,3.86,0,0,0,74.245,6H55.238a3.8,3.8,0,1,0,0,7.6h9.846L43.833,34.854,31.326,22.309a3.8,3.8,0,0,0-5.4,0L3.119,45.118a3.817,3.817,0,1,0,5.4,5.4l20.11-20.148L41.134,42.913a3.8,3.8,0,0,0,5.4,0l23.912-23.95v9.846a3.8,3.8,0,0,0,7.6,0V9.8A3.8,3.8,0,0,0,77.743,8.357Z",
    transform: "translate(-1.994 -6)",
    fill: "#efa462"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.aab5eadedca53aed2a6d54d60addbd04.svg";
export { ForwardRef as ReactComponent };